import React from 'react';
import { Avatar, Box, Stack, Typography, useTheme } from '@mui/material'
import { tokens } from 'theme/tokens';

const StatBox = ({
  title,
  statHighlight,
  statBreakdown,
  icon,
  iconBackgroundColor,
  backgroundColor
}) => {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box m='5px 0px'
      sx={{
        padding: 1,
        borderRadius: 1,
        border: `1px solid ${colors.neutral[200]}`,
        backgroundColor: backgroundColor || colors.neutral[100],
        width: '100%'
      }}
    >
      <Box display={'flex'} justifyContent={'space-between'}>
        <Stack>
          <Typography variant='subtitle2'>{title}</Typography>
          <Typography variant='h5' fontWeight={700}>{statHighlight}</Typography>
        </Stack>
        {icon && <Avatar sx={{backgroundColor: iconBackgroundColor}}>{icon}</Avatar>}
      </Box>
      <Box display='flex' justifyContent='space-between' mt={2} textAlign={'center'}>
        {statBreakdown && statBreakdown.map((stat, idx) =>
          <Box key={`${title}-${idx}`}>
            <Typography variant='body1' fontWeight={600}>{stat.value}</Typography>
            <Typography variant='caption'>
              {stat.status.toLowerCase()} {stat.count && `(${stat.count})`}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default StatBox;